import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewRoutingModule } from './views.routing';
import { SharedModule } from '../shared/shared.module';
import { ComponentsCarouselModule } from 'src/app/components/carousel/components.carousel.module';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeadroomModule } from '@ctrl/ngx-headroom';
import { HomeComponent } from './home/home.component';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { AuthGuard } from '../shared/auth.guard';
import {ComponentsStateButtonModule} from '../components/state-button/components.state-button.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {GlobalService} from "../shared/global.service";
import {TermsOfUseComponent} from "./terms-of-use/terms-of-use.component";
import { PropplePoliciesComponent } from './propple-policies/propple-policies.component';
@NgModule({
  declarations: [
    HomeComponent,
    TermsOfUseComponent,
    PropplePoliciesComponent
  ],
  imports: [
    CommonModule,
    ViewRoutingModule,
    SharedModule,
    ComponentsCarouselModule,
    TabsModule.forRoot(),
    BrowserAnimationsModule,
    HeadroomModule,
    ScrollToModule.forRoot(),
    ComponentsStateButtonModule,
    FormsModule,
    ReactiveFormsModule,
    SimpleNotificationsModule,

  ],
  providers: [AuthGuard],
})
export class ViewsModule {}
